module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('van-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "border-radius": "5px",
      "height": "60px",
      "font-size": "20px"
    },
    attrs: {
      "type": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXueyuan(0)
      }
    }
  }, [_vm._v("学员登录")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "border-radius": "5px",
      "height": "60px",
      "font-size": "20px"
    },
    attrs: {
      "type": "info",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXueyuan(1)
      }
    }
  }, [_vm._v("驾校登录")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6a7dd50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 490
// module chunks = 1